<template>
	<div>
		<breadcrumb :routerList="[{to:'/supervisorDetails-hyj',title:'信贷管理'},{title:'主管详情'}]"/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-pieceIn3">
					<div class="h-pieceTitle2 h-mrb0">
						<h1>数据总计图表</h1>
					</div>
					<div class="h-pieceInCon3 h-mrt30">
						<div class="h-pieChartout">
							<div class="h-pieChart">
								<div id="h_pieChart" style="width: 100%; height: 2.3rem;"></div>
								<div class="h-chartTxt">
									<span>账户余额</span>
									<p>16000元</p>
								</div>
							</div>
							<div class="h-pieChart">
								<div id="h_pieChart2" style="width: 100%; height: 2.3rem;"></div>
								<div class="h-chartTxt">
									<span>信贷余额</span>
									<p>16000元</p>
								</div>
							</div>
							<div class="h-pieChart">
								<div id="h_pieChart3" style="width: 100%; height: 2.3rem;"></div>
								<div class="h-chartTxt">
									<span>返利金额</span>
									<p>16000元</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-piece h-mrt30">
				<div class="h-formBox">
					<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
					 <el-form-item label="客户名称">
						<el-input></el-input>
					  </el-form-item>
					  <el-form-item label="释放时间">
						<el-date-picker type="date" placeholder="选择时间"></el-date-picker>
					  </el-form-item>
					  <el-form-item label="中信保批复账期">
						<el-date-picker type="date" placeholder="选择时间"></el-date-picker>
					  </el-form-item>
					  <el-form-item class="h-formBtnOut">
						<el-button class="h-btn h-formBtn">检索</el-button>
					  </el-form-item>
					</el-form>
				</div>
			</div>
			<div class="h-table h-mrt30">
				<el-table
				 ref="multipleTable"
				 @selection-change="handleSelectionChange"
				:data="tableData2"
				@header-click="headerClick"
				stripe
				border
				style="width: 100%"
				>
				<el-table-column
				  type="selection"
				  width="55"
				  label="全选"
				  >
				</el-table-column>
				<el-table-column
				  fixed
				  type="index"
				  label="#"
				  width="40">
				</el-table-column>
				<el-table-column
				  prop="tableCon1"
				  label="科目"
				   :show-overflow-tooltip="true"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="tableCon2"
				  sortable
				  label="凭证编号"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="tableCon3"
				  label="凭证类型"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="tableCon4"
				  label="记账代码"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="tableCon5"
				  label="借/贷标识"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="tableCon6"
				  label="凭证日期"
				  width="200">
				</el-table-column>
				<el-table-column
				  prop="tableCon7"
				  label="总账科目"
				  width="200">
				</el-table-column>
				<el-table-column
				  label="操作"
				  fixed="right"
				  width="100"
				  >
				  <template slot-scope="scope">
					<el-button
					  type="text"
					  size="small"
					  class="h-tableLink h-btn">
							查看
					</el-button>
				  </template>
				</el-table-column>
			  </el-table>
				<div class="h-tableB h-mrt30">
					<div class="h-tableBL">
						<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>
					</div>
					<div class="h-pagination2">
						<span class="h-pagiLabel">显示数量:</span>
						<el-pagination
						  @size-change="handleSizeChange"
						  @current-change="handleCurrentChange"
						  :current-page="4"
						  :page-sizes="[10, 20, 30, 40]"
						  :page-size="10"
						  layout="sizes, prev, pager, next,jumper"
						  :total="400">
						</el-pagination>
					</div>
				</div>
			</div>
			<el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2">
			  <div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>新增额度申请</h1>
						<p>New quota application</p>
					</div>
				</div>
			  </div>
			  <div class="h-formLine">
				  <el-form ::model="formLabelAlign2" :label-position="right" :rules="rules2" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="客户名称" class="h-elformWrap-2" prop="formCon1">
						<el-input v-model="formLabelAlign2.formCon1"></el-input>
					  </el-form-item>
					  <el-form-item label="申请金额" class="h-elformWrap-2" prop="formCon2">
						<el-input v-model="formLabelAlign2.formCon2"></el-input>
					  </el-form-item>
					  <el-form-item label="承诺回款时间" class="h-elformWrap-2" prop="formCon3">
						<el-date-picker type="date" placeholder="选择时间" v-model="formLabelAlign2.formCon3"></el-date-picker>
					  </el-form-item>
					 <el-form-item label="是否有签字/预期" class="h-elformWrap-2" prop="formCon4">
						<el-select v-model="formLabelAlign2.formCon4" placeholder="请选择">
						  <el-option label="是" value="type1"></el-option>
						  <el-option label="否" value="type2"></el-option>
						</el-select>
					  </el-form-item>
					  <el-form-item label="签字单位" class="h-elformWrap-2" prop="formCon5">
						<el-input v-model="formLabelAlign2.formCon5"></el-input>
					  </el-form-item>
					  <el-form-item label="申报时间" class="h-elformWrap-2" prop="formCon6">
						<el-date-picker type="date" placeholder="选择时间" v-model="formLabelAlign2.formCon6"></el-date-picker>
					  </el-form-item>
					  <el-form-item label="批复账期" class="h-elformWrap-2" prop="formCon7">
						<el-date-picker type="date" placeholder="选择时间" v-model="formLabelAlign2.formCon7"></el-date-picker>
					  </el-form-item>
					  <el-form-item label="批复凭证" class="h-elformWrap-1" prop="formCon8">
						<div class="h-uploadPhoto">
							<el-upload
							  action="https://jsonplaceholder.typicode.com/posts/"
							  list-type="picture-card"
							  :on-preview="handlePictureCardPreview"
							  :on-remove="handleRemove">
							  <i class="el-icon-plus"></i>
							</el-upload>
							<el-dialog :visible.sync="dialogVisible">
							  <img width="100%" :src="dialogImageUrl" alt="">
							</el-dialog>
						</div>
					  </el-form-item>
				  </el-form>
			  </div>
			  <div slot="footer" class="dialog-footer">
				  <el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
				<el-button class="h-btn h-formBtn h-bgblueQ2" @click="dialogFormVisible = false">新增回款</el-button>
				<el-button class="h-btn h-formBtn h-bggreen" @click="dialogFormVisible = false">暂存草稿</el-button>
			  </div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
    export default {
        data() {
            return {
                //表单
			        formInline:{
			        	customerName:'',
			        	date1:'',
			        	date2:'',
			        	date3:'',
			        	type:''
			        },
			        //表格
				     multipleSelection: [],
				     tableData2: [{
				          tableCon1: 'HU87889955664',
				          tableCon2:'14000888776',
				          tableCon3: 'DZ',
				          tableCon4: '11',
				          tableCon5: 'H',
				          tableCon6: '2019-07-13 15:03',
				          tableCon7: '112230987',
				        },{
				          tableCon1: 'HU87889955664',
				          tableCon2:'14000888776',
				          tableCon3: 'DZ',
				          tableCon4: '11',
				          tableCon5: 'H',
				          tableCon6: '2019-07-13 15:03',
				          tableCon7: '112230987',
				        },{
				          tableCon1: 'HU87889955664',
				          tableCon2:'14000888776',
				          tableCon3: 'DZ',
				          tableCon4: '11',
				          tableCon5: 'H',
				          tableCon6: '2019-07-13 15:03',
				          tableCon7: '112230987',
				        },{
				          tableCon1: 'HU87889955664',
				          tableCon2:'14000888776',
				          tableCon3: 'DZ',
				          tableCon4: '11',
				          tableCon5: 'H',
				          tableCon6: '2019-07-13 15:03',
				          tableCon7: '112230987',
				        },{
				          tableCon1: 'HU87889955664',
				          tableCon2:'14000888776',
				          tableCon3: 'DZ',
				          tableCon4: '11',
				          tableCon5: 'H',
				          tableCon6: '2019-07-13 15:03',
				          tableCon7: '112230987',
				        },{
				          tableCon1: 'HU87889955664',
				          tableCon2:'14000888776',
				          tableCon3: 'DZ',
				          tableCon4: '11',
				          tableCon5: 'H',
				          tableCon6: '2019-07-13 15:03',
				          tableCon7: '112230987',
				        },],
				        
				        //弹框
				        dialogFormVisible:false,
				        formLabelAlign2:{
				        	formCon1:'',
				        	formCon2:'',
				        	formCon3:'',
				        	formCon4:'',
				        	formCon5:'',
				        	formCon6:'',
				        	formCon7:'',
				        	formCon8:'',
				        },
            }
        },
        methods: {
            //表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			  },
			  pieChart(){
				let pieChart = this.$echarts.init(document.getElementById('h_pieChart'));
				let option = {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b}: {c} ({d}%)"
					},
					color:['#afe5fc','#17b6fa'],
					legend: {
						show:true,
						orient: 'vertical',
						right: '10%',
						top:'middle',
						data: [{
							name: '信贷余额',
							icon: 'rect',
						},{
							name: '现金余额',
							icon: 'rect',
						}],
						itemWidth:26,
						itemHeight:18,
						borderRadius:0,
						itemGap:30,
						textStyle:{
							color:'#494949',
							fontSize:18,
							padding:[0,0,0,10]
						}
					},
					grid:{
						left:0,
						top:0,
						right:0,
						bottom:0,
						borderWidth: 0
					},
					calculable: true,
					series: [{
							name: '账户余额',
							type:'pie',
							selectedMode: 'single',
							radius: [0, '80%'],
							center:['30%','50%'],
							label: {
								show:false
							},
							labelLine: {
								normal: {
									show: false
								}
							},
							zlevel:10,
							data:[
								{value:335, name:'信贷余额', selected:true},
								{value:679, name:'现金余额'},
							]
							
						}
					]
				};
				pieChart.setOption(option);
			},
			pieChart2(){
				let pieChart = this.$echarts.init(document.getElementById('h_pieChart2'));
				let option = {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b}: {c} ({d}%)"
					},
					color:['#afe5fc','#17b6fa'],
					legend: {
						show:true,
						orient: 'vertical',
						right: '10%',
						top:'middle',
						data: [{
							name: '信贷余额',
							icon: 'rect',
						},{
							name: '现金余额',
							icon: 'rect',
						}],
						itemWidth:26,
						itemHeight:18,
						borderRadius:0,
						itemGap:30,
						textStyle:{
							color:'#494949',
							fontSize:18,
							padding:[0,0,0,10]
						}
					},
					grid:{
						left:0,
						top:0,
						right:0,
						bottom:0,
						borderWidth: 0
					},
					calculable: true,
					series: [{
							name: '账户余额',
							type:'pie',
							selectedMode: 'single',
							radius: [0, '80%'],
							center:['30%','50%'],
							label: {
								show:false
							},
							labelLine: {
								normal: {
									show: false
								}
							},
							zlevel:10,
							data:[
								{value:150, name:'信贷余额', selected:true},
								{value:679, name:'现金余额'},
							]
							
						}
					]
				};
				pieChart.setOption(option);
			},
			pieChart3(){
				let pieChart =this.$echarts.init(document.getElementById('h_pieChart3'));
				let option = {
					tooltip: {
						trigger: 'item',
						formatter: "{a} <br/>{b}: {c} ({d}%)"
					},
					color:['#afe5fc','#17b6fa'],
					legend: {
						show:true,
						orient: 'vertical',
						right: '10%',
						top:'middle',
						data: [{
							name: '已用',
							icon: 'rect',
						},{
							name: '未用',
							icon: 'rect',
						}],
						itemWidth:26,
						itemHeight:18,
						borderRadius:0,
						itemGap:30,
						textStyle:{
							color:'#494949',
							fontSize:18,
							padding:[0,0,0,10]
						}
					},
					grid:{
						left:0,
						top:0,
						right:0,
						bottom:0,
						borderWidth: 0
					},
					calculable: true,
					series: [{
							name: '账户余额',
							type:'pie',
							selectedMode: 'single',
							radius: [0, '80%'],
							center:['30%','50%'],
							label: {
								show:false
							},
							labelLine: {
								normal: {
									show: false
								}
							},
							zlevel:10,
							data:[
								{value:335, name:'已用', selected:true},
								{value:179, name:'未用'},
							]
							
						}
					]
				};
				pieChart.setOption(option);
			},
        },
		mounted(){
			this.pieChart();
			this.pieChart2();
			this.pieChart3();
		  },
    }
</script>

<style>
</style>
